import { API_ENDPOINTS } from './api-endpoints';

export const environmentDefaults = {
  hostname: 'localhost',
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.COMMON,
  DIS_API_KEY: API_ENDPOINTS.DIS_API_KEY.COMMON,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.COMMON,
  PERFORM_APP_DYNAMICS: false,
  APP_DYNAMIC_KEY: '',
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.COMMON,
  WAF_URL: API_ENDPOINTS.WAF_URL.COMMON,
  // angular-cli compile mode
  production: true
};
